import { useState } from 'react';

const useAlertDialog = () => {
  const [alertDialog, setAlertDialog] = useState({
    open: false,
    title: '',
    message: '',
    severity: 'info',
    confirmText: 'OK',
    cancelText: 'Cancel',
    showCancel: false,
    onConfirm: null,
  });

  const showAlert = (titleOrOptions, messageArg, severityArg) => {
    let title, message, severity, confirmText, cancelText, showCancel, onConfirm;
    if (typeof titleOrOptions === 'string') {
      title = titleOrOptions;
      message = messageArg || '';
      severity = severityArg || 'info';
      confirmText = 'OK';
      cancelText = 'Cancel';
      showCancel = false;
      onConfirm = null;
    } else {
      ({
        title,
        message,
        severity = 'info',
        confirmText = 'OK',
        cancelText = 'Cancel',
        showCancel = false,
        onConfirm = null,
      } = titleOrOptions || {});
    }

    setAlertDialog({
      open: true,
      title: title || '',
      message: message || '',
      severity,
      confirmText,
      cancelText,
      showCancel,
      onConfirm,
    });
  };

  const closeAlert = () => {
    setAlertDialog(prev => ({ ...prev, open: false }));
  };

  return {
    alertDialog,
    showAlert,
    closeAlert,
  };
};

export default useAlertDialog;
